import React from 'react';
import { useTranslation } from 'react-i18next';

import Icon from '../../../../components/icon/Icon';
import InteractiveElement from '../../../../components/interactive-element/InteractiveElement';
import deliveryZoneColorMap from '../../../../core/constants/deliveryZoneColorMap';
import { Color } from '../../../../core/enums/Color';
import { Size } from '../../../../core/enums/Size';
import { BarrierDeviceMode } from '../../../../core/state/barriers/types';
import { DeliveryZone } from '../../../../core/state/zones/types';
import Badge from '../../../components/badge/Badge';
import ManageDeliveryZoneModal from '../../modals/manage-delivery-zone/ManageDeliveryZoneModal';

import './DeliveryZoneCard.scss';

interface Props {
  order: number;
  zone: DeliveryZone;
}

const DeliveryZoneCard: React.FC<Props> = ({ zone, order }) => {
  const { t } = useTranslation();
  const [isEditModalOpen, setIsEditModalOpen] = React.useState<boolean>(false);

  const getModeColor = (mode: BarrierDeviceMode) => {
    switch (mode) {
      case BarrierDeviceMode.Offline:
        return Color.Red;
      case BarrierDeviceMode.Online:
        return Color.Green;
      default:
        return Color.Grey;
    }
  };

  return (
    <div className={`delivery-zone-card delivery-zone-card--${order} ${!zone.active ? 'delivery-zone-card--disabled' : ''}`}>
      <div className="d-flex justify-content-between">
        <div className="d-flex">
          <Badge icon={order} color={deliveryZoneColorMap[order]} boldLabel size={Size.Large} />
          {zone.barrierDevice && (
            <span className="ml-2">
              <Badge color={getModeColor(zone.barrierDevice?.mode)} size={Size.Medium} label={zone.barrierDevice?.mode} />
            </span>
          )}
        </div>
        <div className="delivery-zone-card__indicator">
          {zone.active ? (
            <Icon className="delivery-zone-card__indicator-icon" icon="check" size="extra-small" svg />
          ) : (
            <Icon className="delivery-zone-card__indicator-icon" icon="deactivated" size="small" svg />
          )}
        </div>
      </div>
      <p className="delivery-zone-card__name text-truncate">{zone.name}</p>
      <InteractiveElement onClick={() => setIsEditModalOpen(true)}>
        <span className="delivery-zone-card__link">{t('projectSettings.deliveryZones.details')}</span>
      </InteractiveElement>

      {isEditModalOpen && (
        <ManageDeliveryZoneModal
          editMode
          deliveryZoneId={zone.id}
          isOpen={isEditModalOpen}
          closeModal={() => setIsEditModalOpen(false)}
          order={order}
        />
      )}
    </div>
  );
};

export default DeliveryZoneCard;
